import HotspotContactForm from '@modules/contact/components/HotspotContactForm/HotspotContactForm'
import { Col, Row } from 'react-bootstrap'

import styles from './ContactForm.module.scss'

export type ContactFormProps = {
    loading: boolean
    show: boolean
    toggleShow: () => void
}

export default function ContactForm({ loading, show, toggleShow }: ContactFormProps) {
    const titleClass = `py-6 px-4 pt-lg-6 ${styles.titleCol}`
    const formClass = `py-4 px-1 px-sm-4 pt-lg-6 px-lg-6 ${styles.formCol}`

    return (
        <section className="formContainer">
            <Row className="flex-row-reverse flex-column-reverse flex-md-row-reverse">
                <Col md={6} className={titleClass}>
                    <h2 className={`section-title-h2 mb-4 ${styles.padText}`}>
                        How can we <span className="text-green">help you?</span>
                    </h2>
                    <p className={styles.padText}>
                        Got a technical issue? Want to send feedback about a beta feature? Let us know.
                    </p>
                </Col>
                <Col md={6} className={formClass}>
                    <HotspotContactForm loading={loading ?? true} show={show ?? false} toggleShow={toggleShow} />
                </Col>
            </Row>
        </section>
    )
}
